/* unplugin-vue-components disabled */import script from "./plugConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./plugConfig.vue?vue&type=script&lang=ts&setup=true"

import "./plugConfig.vue?vue&type=style&index=0&id=130f4caa&lang=less"

const __exports__ = script;

export default __exports__